import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { ThemeService } from '../../../_core/services/theme.service';

@Component({
  selector: 'app-int-game',
  templateUrl: './int-game.component.html',
  styleUrls: ['./int-game.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class IntGameComponent {
  @Input({ required: true }) gameScore: number;
  @Input({ required: true }) setWinner: boolean;
  @Input({ required: true }) setWinnerColor: string;
  @Input({ required: false }) tiebreakScore: string;
  @Input({ required: false }) matchStatus: string;
  public themeService = inject(ThemeService);
  @Input({ required: false }) summaryView: boolean;
}
